import axios from 'axios';

const axiosInstant = axios.create({
  baseURL: (window as any).BASE_URL + (window as any).LOCALE + '/api',
});

axiosInstant.interceptors.request.use(config => {
  // const token = storage.get('AUTH_TOKEN');

  // if (token && token !== 'undefined') {
  //   config.headers.Authorization = `Token ${token}`;
  // }
  return config;
});

axiosInstant.interceptors.response.use(
  response => {
    const data = response.data || {};

    if (data.error) {
      return Promise.reject({
        ...response,
        data,
      });
    }

    return {
      ...response,
      data: {
        success: true,
        error: null,
        response: data,
      },
    };
  },
  error => {
    //console.log('log: error: ', error, axios.isCancel(error));
    if (axios.isCancel(error)) {
      return Promise.reject({
        status: 499,
        statusText: 'Client Closed Request',
        data: { data: { message: 'Client Closed Request' } },
      });
    }

    let { response } = error;

    if (!response) {
      response = {
        status: 599,
        statusText: 'Network connect timeout error',
      };
    }

    const { data } = response;
    const payload = typeof data !== 'object' ? { data: { message: data } } : data;

    return Promise.reject({
      status: response.status,
      statusText: response.statusText,
      ...(payload || {}),
    });
  }
);

export default axiosInstant;
